import React from 'react';
import ReactDOM from 'react-dom';
import Main from './comp/main';
import './index.css';
import {BrowserRouter as Router,Switch,Route} from "react-router-dom"

import reportWebVitals from './reportWebVitals';
import ToyApi from './comp/toyApi';


ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Switch>
        <Route exact path="/" component={Main}/>
        <Route exact path="/toy_api" component={ToyApi}/>
      </Switch>
 
 </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
